export default __webpack_public_path__ + "2020 Photochemistry with Quantum Optics from a Non-Adiabatic Quantum Trajectory Perspective.pdf";